var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetGeolocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333008 2.33301L4.99967 0.333008L8.99967 2.33301L13.2017 0.532341C13.2524 0.510597 13.3077 0.501787 13.3627 0.506703C13.4177 0.511618 13.4706 0.530105 13.5166 0.560504C13.5627 0.590904 13.6005 0.632264 13.6266 0.680873C13.6527 0.729482 13.6664 0.783819 13.6663 0.839008V11.6663L8.99967 13.6663L4.99967 11.6663L0.797675 13.467C0.74695 13.4888 0.691621 13.4976 0.636652 13.4926C0.581683 13.4877 0.528794 13.4692 0.482733 13.4388C0.436671 13.4084 0.398878 13.3671 0.372746 13.3185C0.346613 13.2699 0.332959 13.2155 0.333008 13.1603V2.33301ZM9.66634 11.9297L12.333 10.787V2.35501L9.66634 3.49767V11.9297ZM8.33301 11.8423V3.49034L5.66634 2.15701V10.509L8.33301 11.8423ZM4.33301 10.5017V2.06967L1.66634 3.21234V11.6443L4.33301 10.5017Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetGeolocation);
export default __webpack_public_path__ + "static/media/getGeolocation.2caadaf864ca3b7ff84d17774f74a7f9.svg";
export { ForwardRef as ReactComponent };